import { SmartfireIcon } from './SmartfireIcon.js';
import { createElement } from 'react';
export const defaultBlockIcon = createElement(SmartfireIcon, { color: 'unset' });
/**
 * Transform a React component to a block usable by Smartfire.
 *
 * Smartfire handles any React component, but some metadata can be
 * required to use in conjunction with tools like Gutenberg Editor.
 *
 * This methods handles your specified setup configuration, if a
 * required setting is not provided a default one will be provided.
 *
 * @param setup {React.Component|*} The React component to setup
 * @param smartProps {Map<string, smartProps>} Properties setup for the component, if you use editor update,
 *                                             you have to register your properties
 * @param configuration {BlockConfiguration} Configuration to pass on editor
 * @returns {React.Component}
 */
export default function defineBlock({ Block: component, smartProps = {}, setup = {}, }) {
    let smartComponent = Object.assign(component, {
        smartProps,
        _smartfire: {
            setup
        }
    });
    return smartComponent;
}

//# sourceMappingURL=defineBlock.js.map
